import * as types from '../mutation-types'
import axios from '../../utils/axios'
import { isEmpty } from 'lodash'

export const state = {
  currency: [],
  loading: false,
};

// getters
export const getters = {
  currency: state => state.currency,
  loading: state => state.loading
};

// mutations
export const mutations = {
  [types.SET_CURRENCY](state, data) {
    state.currency = data.map(item => {
      return {
        label: item.title,
        value: item.title
      }
    })
  },
  [types.SET_CURRENCY_LOADING](state, data) {
    state.loading = data;
  }
};

// actions
export const actions = {
  async getCurrency({ commit, state }) {
    if (isEmpty(state.currency) && !state.loading) {
      await commit(types.SET_CURRENCY_LOADING, true);

      const { data } = await axios.get('/admin/currency');
      await commit(types.SET_CURRENCY, data.items);

      await commit(types.SET_CURRENCY_LOADING, false);
    }
  }
};
